import { createRoute, redirect } from '@tanstack/react-router'

import { lazyPage } from '@/lib/lazy-page'

import { globalReportsRoute, reportsRoute } from './reports-route'

export function decodeQueryExplorerSearch(search: Record<string, unknown>): { sql?: string } {
  return typeof search.sql === 'string' ? { sql: search.sql } : {}
}

export function decodeReportBuilderSearch(search: Record<string, unknown>): { q?: string } {
  return typeof search.q === 'string' ? { q: search.q } : {}
}

export const QueryExplorer = lazyPage(() => import('./features/query-explorer/query-explorer.lazy'), 'QueryExplorer')
export const ReportBuilder = lazyPage(() => import('./features/report-builder/report-builder.lazy'), 'ReportBuilder')
export const ReportsList = lazyPage(() => import('./features/reports-list/reports-list.lazy'), 'ReportsList')

export const reportsIndexRoute = createRoute({
  getParentRoute: () => reportsRoute,
  path: '/',
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$entityId/reports/all',
      params: { entityId: params.entityId },
      replace: true,
    })
  },
})

export const globalReportsIndexRoute = createRoute({
  getParentRoute: () => globalReportsRoute,
  path: '/',
  beforeLoad: () => { throw redirect({ to: '/reports/new', replace: true }) },
})

export const reportsListRoute = createRoute({
  getParentRoute: () => reportsRoute,
  path: 'all',
  component: ReportsList,
})

export const reportBuilderRoute = createRoute({
  getParentRoute: () => reportsRoute,
  path: 'new',
  validateSearch: decodeReportBuilderSearch,
  component: ReportBuilder,
  staticData: { title: 'Report builder' },
})

export const reportDetailRoute = createRoute({
  getParentRoute: () => reportsRoute,
  path: '$reportId',
  validateSearch: decodeReportBuilderSearch,
  component: ReportBuilder,
})

export const globalReportBuilderRoute = createRoute({
  getParentRoute: () => globalReportsRoute,
  path: 'new',
  validateSearch: decodeReportBuilderSearch,
  component: ReportBuilder,
  staticData: { title: 'Report builder' },
})

export const queryExplorerRoute = createRoute({
  getParentRoute: () => reportsRoute,
  path: 'query',
  validateSearch: decodeQueryExplorerSearch,
  component: QueryExplorer,
  staticData: { title: 'Query explorer' },
})

export const globalQueryExplorerRoute = createRoute({
  getParentRoute: () => globalReportsRoute,
  path: 'query',
  validateSearch: decodeQueryExplorerSearch,
  component: QueryExplorer,
  staticData: { title: 'Query explorer' },
})
